import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getActiveFilters, getSearchView } from 'selectors/search';
import {
  organisationEmployeeCount,
  organisationFoundationYear,
  organisationsTypeahead,
} from 'services/inputTokens';
import { Filter } from '../helpers';
import FilterGroup from './FilterGroup';
import { orgResearcherKeys, orgOrganisationKeys } from './keys';
import { OrganisationSearch } from '../Results/helpers';
import { tagRender } from 'components/common/TagRender';
import { renderOption } from 'components/common/OptionRender';

const OrgFilters = ({ activeOnly, loading }) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexWrap: 'nowrap',
          alignItems: 'flex-start',
        }}
      >
        <div style={{ flex: 0.5, paddingRight: '10px' }}>
          <Filter
            filterType='selectIncludeExclude'
            filterId={orgOrganisationKeys.superOrganisationSize.key}
            placeholder='Employee Count'
            mode={'multiple'}
            style={{ width: '100%' }}
            renderOption={renderOption}
            tagRender={tagRender}
            helpText='Filter results by the number of employees at an organisation'
            options={organisationEmployeeCount}
            activeOnly={activeOnly}
            disabled={loading}
          />
        </div>
        <Filter
          style={{ flex: 0.5, marginLeft: 'auto' }}
          filterType='select'
          filterId={orgOrganisationKeys.superOrganisationFoundedYear.key}
          placeholder='Year Founded'
          allowClear
          showSearch
          options={organisationFoundationYear}
          activeOnly={activeOnly}
          disabled={loading}
        />
      </div>
      {/*<Filter*/}
      {/*  filterType='number'*/}
      {/*  filterId='minRevenue'*/}
      {/*  formatter={formatCurrency}*/}
      {/*  placeholder='Min. Revenue (Yearly)'*/}
      {/*  step={10000}*/}
      {/*  min={0}*/}
      {/*  helpText='Filter results by the minimum yearly revenue for an organisation'*/}
      {/*/>*/}
      {/*<Filter*/}
      {/*  filterType='number'*/}
      {/*  filterId='maxRevenue'*/}
      {/*  formatter={formatCurrency}*/}
      {/*  placeholder='Max. Revenue (Yearly)'*/}
      {/*  step={10000}*/}
      {/*  min={0}*/}
      {/*  helpText='Filter results by the maximum yearly revenue for an organisation'*/}
      {/*/>*/}
    </>
  );
};

const Organisation = ({ loading }) => {
  const isOrgView = OrganisationSearch(useSelector(getSearchView));

  const activeFilters = useSelector(
    getActiveFilters(
      isOrgView
        ? Object.keys(orgOrganisationKeys)
        : Object.keys(orgResearcherKeys)
    )
  );

  return (
    <FilterGroup
      icon='company'
      title='Organisation'
      activeKeys={activeFilters}
      sectionKey='organisation'
    >
      <>
        <Filter
          filterType='selectIncludeExclude'
          placeholder='Organisations'
          mode={'multiple'}
          style={{ width: '100%' }}
          renderOption={renderOption}
          tagRender={tagRender}
          showSearch={true}
          filterId={orgOrganisationKeys.organisationName.key}
          options={organisationsTypeahead}
          disabled={loading}
        />
        <Filter
          filterType='token'
          placeholder='Email Domains - Max 10'
          filterId={orgOrganisationKeys.email.key}
          tokenLimit={10}
          disabled={loading}
          includeExclude
        />
        {isOrgView && <OrgFilters loading={loading} />}
        <Filter
          filterType='token'
          placeholder='Organisation Description'
          filterId={orgOrganisationKeys.organisationDescription.key}
          disabled={loading}
          includeExclude
        />
        {isOrgView && (
          <Filter
            filterType='checkbox'
            filterId={orgOrganisationKeys.recentlyAddedOrg.key}
            disabled={loading}
            labelText='Added within last month'
          />
        )}
      </>
    </FilterGroup>
  );
};

Organisation.propTypes = {
  loading: PropTypes.bool,
};

export default Organisation;
